import { render } from "./ProjectSmetaTabs.vue?vue&type=template&id=0042ea75&scoped=true"
import script from "./ProjectSmetaTabs.vue?vue&type=script&lang=js"
export * from "./ProjectSmetaTabs.vue?vue&type=script&lang=js"

import "./ProjectSmetaTabs.vue?vue&type=style&index=0&id=0042ea75&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0042ea75"]])

export default __exports__